import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left"
import { GenericBoxWithLabels } from "../../tools/components/genericBoxWithLabels"
import { AllowProtM024List } from "./list/allowProtM024List"
import { useEffect, useState } from "react"
import { GetAllEntryProtocolAttachments, resetGetAllEntryProtocolAttachmentsStatus } from "../../protocol/entry/slice"
import { AttachmentM024DTO, M024DetailBulkConfUpdateDTO, M024UpdateOptionsDTO } from "./dataService/dto"
import { setM024Attachments, setUpdateActiveM024DetailsRequest } from "./slice"
import Button from "../../../ui/molecules/button"
import { PlusIcon } from "../../../ui/icons/plus"
import { SelectCustom } from "../../../ui/molecules/select"
import { normativa, yearOptions } from "../../../utils"
import './style.scss'
import { M024OptionsForm } from "./m024Options"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { TrashIcon } from "../../../ui/icons/trash"
import { OtherProtM024List } from "./list/otherProtM024List"
import { Alert } from "../../../ui/organisms/alert"
import { MembriOrganoCollegiale } from "./components/listMembri"

export function EditRiesameM024() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const m024State = useAppSelector(state => state.m024)
    const [showPopupMembri, setShowPopupMembri] = useState<boolean>(false);
    const [showAlertDelete, setShowAlertDelete] = useState<boolean>(false)

    useEffect(() => {
        dispatch(GetAllEntryProtocolAttachments({
            bio: sessionState.selected.customerNorm === 'NORMA_BIO' ? true : undefined,
            // globalGap: sessionState.selected.customerNorm === 'GLOBAL_GAP' ? true : undefined,
            // sqnpi: sessionState.selected.customerNorm === 'PRODUZIONE_INTEGRATA' ? true : undefined,
            // generics: genericsFilterPredicate(sessionState.selected.customerNorm!),
            itemsPerPage: 0,
            page: 0
        }))

    }, [])

    const handleOnSave = () => {
        const activeBulk: M024DetailBulkConfUpdateDTO[] = m024State.activeM024DetailsUpdateRequest.map(actDet => ({
            id: actDet.id,
            m024RowDetailsUpdateDTO: {
                conformityEvaluation: actDet.conformityEvaluation ?? undefined,
                riesameEvaluation: actDet.riesameEvaluation ?? undefined,
                note: actDet.note
            }
        }))

        const updateOptions: M024UpdateOptionsDTO = {
            certificationDocumentM029: m024State.m024UpdateRequest.certificationDocumentM029,
            certificationDocumentM014: m024State.m024UpdateRequest.certificationDocumentM014,
            certificationDocumentM020: m024State.m024UpdateRequest.certificationDocumentM020,
            certificationDocumentM021: m024State.m024UpdateRequest.certificationDocumentM021,
            certificationDocumentM023: m024State.m024UpdateRequest.certificationDocumentM023,
            certificationDocumentNaqs: m024State.m024UpdateRequest.certificationDocumentNaqs,
            admConformity: m024State.m024UpdateRequest.admConformity,
            admRegularityProtocol: m024State.m024UpdateRequest.admRegularityProtocol,
            issueDate: m024State.m024UpdateRequest.issueDate,
            nopDetails: m024State.m024UpdateRequest.nopDetails,
            otherReason: m024State.m024UpdateRequest.otherReason,
            reasonsEmissioNot: m024State.m024UpdateRequest.reasonsEmissioNot,
            reasonsEmissionM029Rev: m024State.m024UpdateRequest.reasonsEmissionM029Rev,
            reasonsEmissionM029Request: m024State.m024UpdateRequest.reasonsEmissionM029Request,
            reasonsEmissionPsr: m024State.m024UpdateRequest.reasonsEmissionPsr,
            requestCertProtocol: m024State.m024UpdateRequest.requestCertProtocol,
            // ... altri di options
            details: activeBulk
        }
        console.log('salvataggio ', updateOptions)
    }

    useEffect(() => {
        const dataAttachAllow = [
            {
                "id": "1",
                "customerId": "5023",
                "entryProtocolId": "1",
                "entryProtocolDescription": "SC E00001/2015",
                "entryProtocolAttachmentId": "293",
                "conformityEvaluation": true,
                "note": "test",
                "fileId": null,
            },
            {
                "id": "2",
                "customerId": "5023",
                "entryProtocolId": "1",
                "entryProtocolDescription": "SC E00021/2015",
                "entryProtocolAttachmentId": "292",
                "conformityEvaluation": true,
                "note": "test",
                "fileId": null,
            },
            {
                "id": "3",
                "customerId": "5023",
                "entryProtocolId": "1",
                "entryProtocolDescription": "SC E00021/2015",
                "entryProtocolAttachmentId": "285",
                "conformityEvaluation": true,
                "note": "test",
                "fileId": null,
            }
        ]
        dispatch(setUpdateActiveM024DetailsRequest(dataAttachAllow))
    }, [])

    const membriColleg = [
        {
            id: '1',
            name: 'Alfio Tirendi',
            office: 'UCO',
            date: '10/11/2025',
            place: 'Scordia (CT)'
        },
        {
            id: '1',
            name: 'Alfio Trenta',
            office: 'UCE',
            date: '10/11/2025',
            place: 'Scordia (CT)'
        },
        {
            id: '1',
            name: 'Alfio Maggio',
            date: '10/11/2025',
            office: 'UCO',
            place: 'Scordia (CT)'
        },
    ]

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolAttachmentsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolAttachmentsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolAttachmentsStatus())
            const M024Atts: AttachmentM024DTO[] = entryProtocolState.getAllEntryProtocolAttachmentsResponse.data.map(epAtt => {
                return {
                    id: epAtt.id,
                    code: epAtt.coding,
                    attachmentName: epAtt.description,
                    protocolDetailIds: []
                } as unknown as AttachmentM024DTO
            })

            dispatch(setM024Attachments(M024Atts))
        }
    }, [entryProtocolState.getAllEntryProtocolAttachmentsStatus])

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Dettaglio M024']}
            noPaddingLat
            headerLabel="Riesame"
            headerIcon={
                <button style={{ paddingTop: '12px' }} onClick={() => {
                    navigate('/listM024')
                }}>
                    <ArrowLeftIcon />
                </button>
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end" style={{ justifyContent: 'end' }}>
                    <Button
                        iconPosition='off'
                        variant='solid'
                        color='orange'
                        size='sm'
                        label='Salva'
                        onClick={() =>
                            handleOnSave()
                        }
                    />
                </div>
            }
        >
            <div>
                <div className="m024-tools flex flex-col md:flex-row items-start md:items-center gap-6" style={{ padding: '24px' }}>
                    <div>
                        <Button
                            variant="outline"
                            color="dimgrey"
                            iconPosition="left"
                            icon={<PlusIcon color="orange" size={16} />}
                            size="sm"
                            label="Importa da Cartella Aziendale"
                            onClick={() => console.log('copia')}
                        />
                    </div>

                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                        <span>Copia da Valutazione precedente</span>
                        <SelectCustom
                            placeholder="Seleziona Revisione Precedente"
                            options={yearOptions}
                            onChange={(value) => console.log('copia da revisione')}
                        />
                        <Button
                            variant="outline"
                            color="dimgrey"
                            iconPosition="left"
                            icon={<PlusIcon color="orange" size={16} />}
                            size="sm"
                            label="Copia"
                            onClick={() => console.log('copia')}
                        />
                    </div>
                </div>
                <div className="formFieldset-container">
                    <div className='formFieldset-header'>
                        <div className='text-left'>
                            <span className='rid-title' style={{ color: '#fff' }}>Dati M024</span>
                        </div>
                    </div>
                    <div>
                        <M024OptionsForm documentType="RIESAME" />
                    </div>
                </div>
                <div style={{ padding: '24px' }}>
                    <div className="table-head-ca uppercase" style={{ display: 'flex' }}>
                        <th style={{ flex: '5%' }}></th>
                        <th style={{ flex: '25%' }}>Riferimento protocolli</th>
                        <th style={{ flex: '40%', maxWidth: '1000px' }}>Note</th>
                        <th style={{ flex: '15%', textAlign: 'center' }}>Valutazione conformità</th>
                        <th style={{ flex: '15%', textAlign: 'center' }}>Riesame conformità</th>
                    </div>
                    <AllowProtM024List documentType={'RIESAME'} />
                    <OtherProtM024List documentType={'RIESAME'} />
                    <MembriOrganoCollegiale />
                </div>
            </div>
        </Layout>
    )

}